<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-boolean`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_97b0b64993__clip0_3190_335346)"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.29033 3.29262C8.01402 2.31787 9.17329 1.6875 10.4787 1.6875C12.6704 1.6875 14.4471 3.46419 14.4471 5.65585C14.4471 7.0607 13.7168 8.29622 12.6141 9.00155C12.3795 6.0814 10.1505 3.72403 7.29033 3.29262ZM5.55674 3.27079C6.44189 1.44714 8.31247 0.1875 10.4787 0.1875C13.4988 0.1875 15.9471 2.63577 15.9471 5.65585C15.9471 7.95671 14.5265 9.92403 12.5163 10.7318C11.9484 13.622 9.40101 15.8022 6.34434 15.8022C2.87039 15.8022 0.0541992 12.9861 0.0541992 9.5121C0.0541992 6.30489 2.45453 3.6583 5.55674 3.27079ZM1.5542 9.5121C1.5542 6.86658 3.69882 4.72196 6.34434 4.72196C8.98987 4.72196 11.1345 6.86658 11.1345 9.5121C11.1345 12.1576 8.98987 14.3022 6.34434 14.3022C3.69882 14.3022 1.5542 12.1576 1.5542 9.5121Z"/></g><defs><clipPath id="svg_97b0b64993__clip0_3190_335346"><path d="M0 0H16V16H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconLineBoolean',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
